import { GlobeIcon as PhosphorGlobeIcon } from "@phosphor-icons/react/dist/ssr/Globe";

import { createAppIcon } from "@/components/createAppIcon";

export const GlobeIcon = /* @__PURE__ */ createAppIcon(PhosphorGlobeIcon);
